import React, { useState, useEffect } from "react";
import "./RyujinImages.css";
const ryujinImages = [
  {
    src: "./itzy-ryujin/ryujin-001.jpg",
    alt: "Ryujin Image 1",
    title: "ryujin-001.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-002.jpg",
    alt: "Ryujin Image 2",
    title: "ryujin-002.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-003.jpeg",
    alt: "Ryujin Instagram Update",
    title: "ryujin-003.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-004.jpeg",
    alt: "Ryujin Image 3",
    title: "ryujin-004.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-005.webp",
    alt: "Ryujin Happy Day",
    title: "ryujin-005.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-006.jpg",
    alt: "Ryujin Image 4",
    title: "ryujin-006.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-007.jpg",
    alt: "Ryujin Image 5",
    title: "ryujin-007.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-008.jpg",
    alt: "Ryujin Image 6",
    title: "ryujin-008.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-009.jpg",
    alt: "Ryujin Image 7",
    title: "ryujin-009.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-010.jpg",
    alt: "Ryujin Image 8",
    title: "ryujin-010.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-011.jpg",
    alt: "Ryujin Image 9",
    title: "ryujin-011.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-012.jpeg",
    alt: "Ryujin Image 10",
    title: "ryujin-012.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-013.jpg",
    alt: "Ryujin Image 11",
    title: "ryujin-013.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-014.jpg",
    alt: "Ryujin Image 12",
    title: "ryujin-014.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-015.jpg",
    alt: "Ryujin Image 13",
    title: "ryujin-015.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-016.jpg",
    alt: "Ryujin Image 14",
    title: "ryujin-016.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-017.jpg",
    alt: "Ryujin Image 15",
    title: "ryujin-017.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-018.jpg",
    alt: "Ryujin Image 16",
    title: "ryujin-018.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-019.jpg",
    alt: "Ryujin Image 17",
    title: "ryujin-019.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-020.jpg",
    alt: "Ryujin Image 18",
    title: "ryujin-020.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-021.jpg",
    alt: "Ryujin Image 19",
    title: "ryujin-021.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-022.jpg",
    alt: "Ryujin Image 20",
    title: "ryujin-022.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-023.jpg",
    alt: "Ryujin Image 21",
    title: "ryujin-023.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-024.jpg",
    alt: "Ryujin Image 22",
    title: "ryujin-024.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-025.jpg",
    alt: "Ryujin Image 23",
    title: "ryujin-025.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-026.jpg",
    alt: "Ryujin Image 24",
    title: "ryujin-026.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-027.jpg",
    alt: "Ryujin Image 25",
    title: "ryujin-027.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-028.jpg",
    alt: "Ryujin Image 26",
    title: "ryujin-028.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-029.jpg",
    alt: "Ryujin Image 27",
    title: "ryujin-029.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-030.jpg",
    alt: "Ryujin Image 28",
    title: "ryujin-030.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-031.jpg",
    alt: "Ryujin Image 29",
    title: "ryujin-031.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-032.jpg",
    alt: "Ryujin Image 30",
    title: "ryujin-032.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-033.jpg",
    alt: "Ryujin Image 31",
    title: "ryujin-033.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-034.jpg",
    alt: "Ryujin Image 32",
    title: "ryujin-034.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-035.jpg",
    alt: "Ryujin Image 33",
    title: "ryujin-035.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-036.jpg",
    alt: "Ryujin Image 34",
    title: "ryujin-036.jpg",
  },
  // {
  //   src: "./itzy-ryujin/ryujin-037.mp4",
  //   alt: "Ryujin Video 1",
  //   title: "ryujin-037.mp4",
  // },
  {
    src: "./itzy-ryujin/ryujin-038.jpg",
    alt: "Ryujin Image 35",
    title: "ryujin-038.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-039.jpg",
    alt: "Ryujin Image 36",
    title: "ryujin-039.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-040.jpg",
    alt: "Ryujin Image 37",
    title: "ryujin-040.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-041.jpg",
    alt: "Ryujin Image 38",
    title: "ryujin-041.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-042.jpg",
    alt: "Ryujin Image 39",
    title: "ryujin-042.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-043.jpg",
    alt: "Ryujin Image 40",
    title: "ryujin-043.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-044.jpg",
    alt: "Ryujin Image 41",
    title: "ryujin-044.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-045.jpeg",
    alt: "Ryujin Image 42",
    title: "ryujin-045.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-046.jpg",
    alt: "Ryujin Image 43",
    title: "ryujin-046.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-047.jpg",
    alt: "Ryujin Image 44",
    title: "ryujin-047.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-048.jpeg",
    alt: "Ryujin Image 45",
    title: "ryujin-048.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-049.jpg",
    alt: "Ryujin Image 46",
    title: "ryujin-049.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-050.jpg",
    alt: "Ryujin Image 47",
    title: "ryujin-050.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-051.webp",
    alt: "Ryujin Image 48",
    title: "ryujin-051.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-052.jpg",
    alt: "Ryujin Image 49",
    title: "ryujin-052.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-053.jpg",
    alt: "Ryujin Image 50",
    title: "ryujin-053.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-054.jpg",
    alt: "Ryujin Image 51",
    title: "ryujin-054.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-055.jpg",
    alt: "Ryujin Image 52",
    title: "ryujin-055.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-056.jpg",
    alt: "Ryujin Image 53",
    title: "ryujin-056.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-057.jpg",
    alt: "Ryujin Image 54",
    title: "ryujin-057.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-058.jpg",
    alt: "Ryujin Image 55",
    title: "ryujin-058.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-059.jpg",
    alt: "Ryujin Image 56",
    title: "ryujin-059.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-060.jpg",
    alt: "Ryujin Image 57",
    title: "ryujin-060.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-061.jpg",
    alt: "Ryujin Image 58",
    title: "ryujin-061.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-062.jpg",
    alt: "Ryujin Image 59",
    title: "ryujin-062.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-063.jpg",
    alt: "Ryujin Image 60",
    title: "ryujin-063.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-064.jpg",
    alt: "Ryujin Image 61",
    title: "ryujin-064.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-065.jpg",
    alt: "Ryujin Image 62",
    title: "ryujin-065.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-066.jpg",
    alt: "Ryujin Image 63",
    title: "ryujin-066.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-067.webp",
    alt: "Ryujin Image 64",
    title: "ryujin-067.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-068.jpeg",
    alt: "Ryujin Image 65",
    title: "ryujin-068.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-070.jpeg",
    alt: "Ryujin Image 66",
    title: "ryujin-070.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-071.jpeg",
    alt: "Ryujin Image 67",
    title: "ryujin-071.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-072.jpeg",
    alt: "Ryujin Image 68",
    title: "ryujin-072.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-073.webp",
    alt: "Ryujin Image 69",
    title: "ryujin-073.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-074.webp",
    alt: "Ryujin Image 70",
    title: "ryujin-074.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-075.jpeg",
    alt: "Ryujin Image 71",
    title: "ryujin-075.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-076.webp",
    alt: "Ryujin Image 72",
    title: "ryujin-076.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-077.png",
    alt: "Ryujin Image 73",
    title: "ryujin-077.png",
  },
  {
    src: "./itzy-ryujin/ryujin-078.png",
    alt: "Ryujin Image 74",
    title: "ryujin-078.png",
  },
  {
    src: "./itzy-ryujin/ryujin-079.webp",
    alt: "Ryujin Image 75",
    title: "ryujin-079.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-080.jpg",
    alt: "Ryujin Image 76",
    title: "ryujin-080.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-081.png",
    alt: "Ryujin Image 77",
    title: "ryujin-081.png",
  },
  {
    src: "./itzy-ryujin/ryujin-082.jpeg",
    alt: "Ryujin Image 78",
    title: "ryujin-082.jpeg",
  },
  {
    src: "./itzy-ryujin/ryujin-083.webp",
    alt: "Ryujin Image 79",
    title: "ryujin-083.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-084.jpg",
    alt: "Ryujin Image 80",
    title: "ryujin-084.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-085.webp",
    alt: "Ryujin Image 81",
    title: "ryujin-085.webp",
  },
  {
    src: "./itzy-ryujin/ryujin-086.jpg",
    alt: "Ryujin Image 82",
    title: "ryujin-086.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-087.jpg",
    alt: "Ryujin Image 83",
    title: "ryujin-087.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-088.jpg",
    alt: "Ryujin Image 84",
    title: "ryujin-088.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-089.jpg",
    alt: "Ryujin Image 85",
    title: "ryujin-089.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-090.jpg",
    alt: "Ryujin Image 86",
    title: "ryujin-090.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-091.jpg",
    alt: "Ryujin Image 87",
    title: "ryujin-091.jpg",
  },
  {
    src: "./itzy-ryujin/ryujin-092.jpg",
    alt: "Ryujin Image 88",
    title: "ryujin-092.jpg",
  },
];

const RyujinImages = () => {
  const [randomizedImages, setRandomizedImages] = useState([]);

  useEffect(() => {
    // Shuffle the images on each page load
    const shuffledImages = [...ryujinImages].sort(() => Math.random() - 0.5);
    setRandomizedImages(shuffledImages);
  }, []);

  // Helper to open image in new tab
  const handleImageClick = (src) => {
    window.open(src, "_blank", "noopener,noreferrer");
  };

  const renderImageRows = (start, end) => (
    <div style={{ display: "flex", alignItems: "start", gap: "2rem" }}>
      {randomizedImages.slice(start, end).map((img) => (
        <div key={img.title} style={{ flex: 1 }} className="ryujinImage">
          <img
            src={img.src}
            alt={img.alt}
            style={{ width: "100%", cursor: "pointer" }}
            onClick={() => handleImageClick(img.src)}
            tabIndex={0}
            role="button"
            aria-label={`Open ${img.title} in new tab`}
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") {
                handleImageClick(img.src);
              }
            }}
          />
          {/* <div className="image-title">{img.title}</div> */}
        </div>
      ))}
    </div>
  );

  return (
    <div className="container">
      <div style={{ flex: 2.5, paddingTop: "2rem" }}>
        <h1
          className="title"
          style={{
            color: "white",
            filter: "brightness(0) invert(1)",
          }}
        >
          ˚₊·—̳͟͞͞🌟 The Prettiest Girl on Earth   ˖°.𓆩 Shin Ryu-jin 𓆪.°˖
        </h1>
        {/* <h1 className="title">˚₊·—̳͟͞͞♡ The Prettiest Girl on Earth   ˖°.𓆩 류진 𓆪.°˖</h1> */}
      </div>
      {/* Desktop grid view */}
      <div className="desktopRyujinImagesList">
        {Array.from({ length: Math.ceil(110 / 3) }, (_, i) =>
          renderImageRows(i * 3, (i + 1) * 3)
        )}
      </div>
      {/* Phone column view */}
      <div className="phoneRyujinImagesList">
        {randomizedImages.map((img) => (
          <div key={img.title} className="ryujinImage">
            <img
              src={img.src}
              alt={img.alt}
              style={{ width: "100%", cursor: "pointer" }}
              onClick={() => handleImageClick(img.src)}
              tabIndex={0}
              role="button"
              aria-label={`Open ${img.title} in new tab`}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  handleImageClick(img.src);
                }
              }}
            />
            {/* <div className="image-title">{img.title}</div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RyujinImages;
